export class DonutChartModel {
    value: number;
    color: string;
    legend: string;
}
